<template>
  <div>
    <a id="twitter" href="https://twitter.com/share?ref_src=twsrc%5Etfw" class="twitter-share-button" data-url="https://qpic.jp/qfes" data-size="large" :data-text="twitterText" data-via="Qpic_Official" data-hashtags="qpic" data-show-count="true">Tweet</a>
   </div>
</template> 

<script>
export default {
  name: 'TwitterButton',
  props: ['title'],
  computed:{
    twitterText: function(){
      if(this.title)
        return 'QVF「' + this.title.replace(/<br>/g,'').replace(/\n/g,'') + '」';
      else
        return '';
    }
  },
  mounted(){
    let a = document.getElementById('twitter');
    let sc = document.createElement('script');
    sc.setAttribute('src','https://platform.twitter.com/widgets.js');
    sc.setAttribute('charset','utf-8');
    a.after(sc);
  }
}
</script>

<style scoped>
</style>
